// =============================================================================
// generatedDocuments.ts — Patch 015.3 frontend API client for the 012.E
// document generator, wired to the scope cascade.
//
// `generateFromCascade` posts { kind, from_cascade_run: true } — the route
// sources the document's scope from the project's latest scope-cascade run
// (project_scope_runs) instead of explicit project_scope_item ids.
// =============================================================================

import { request } from './request'
import type { GeneratedDocumentRow } from './types'

export type GeneratedDocumentKind = 'sow' | 'rfb' | 'sub_agreement' | 'other'

export const generatedDocumentsApi = {
  list: (projectId: string, params?: { kind?: GeneratedDocumentKind }) => {
    const qs = params?.kind ? `?kind=${encodeURIComponent(params.kind)}` : ''
    return request<{ ok: true; documents: GeneratedDocumentRow[]; count: number }>(
      `/api/projects/${encodeURIComponent(projectId)}/generated-documents${qs}`,
    )
  },

  // `trade` restricts the document's scope to one trade's in-scope items.
  // A whole-project SOW is wrong (SOWs are per-trade) and too large to
  // generate in one call, so the per-trade path is the real one.
  generateFromCascade: (
    projectId: string,
    kind: GeneratedDocumentKind,
    trade?: string,
  ) =>
    request<{
      ok: true
      id: string
      kind: string
      status: string
      request_id: string
    }>(`/api/projects/${encodeURIComponent(projectId)}/generated-documents`, {
      method: 'POST',
      body: JSON.stringify({
        kind,
        from_cascade_run: true,
        ...(trade ? { trade } : {}),
      }),
    }),
}
